import React, { FC, useState } from 'react';
import { IKindVersion } from '../../../model/kind/KindVersion';
import { formatISODateStringAsLocal } from '../common/Utils';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { observer } from 'mobx-react-lite';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { IEntityVersion } from '../../../model/entity/EntityVersion';
import { InfoBox, InfoBoxHeader, InfoBoxBody } from '@yakoffice/info-box';
import { CollapsePanel } from '@yakoffice/shared-components';
import { AbbreviatedString } from '../../components/abbreviated-string/AbbreviatedString';
import { useGetKindLink } from '../../routes';
import { Link } from 'react-router-dom';


export const statusToggleClasses: any = {
    published: 'text-success',
    draft: 'text-warning',
    stopped: 'text-danger',
    archived: 'text-secondary'
};

interface PropsType {
    entityVersion: IEntityVersion,
    currentKindVersion: IKindVersion,
    currentGameEnvironment: IGameEnvironment
}

export const EntityHighlights: FC<PropsType> = observer(({
                                                             entityVersion,
                                                             currentKindVersion
                                                         }) => {

    const [comment] = useState(entityVersion.comment);
    const kindLink = useGetKindLink();

    return (
        <CollapsePanel>
            <Row>
                <Col>
                    <InfoBox>
                        <InfoBoxHeader><i className="fas fa-code-branch" />Kind Version</InfoBoxHeader>
                        {entityVersion.isOnOldVersionOfKind()
                            ?
                            <InfoBoxBody className="text-warning fw-bold">
                                <Link to={kindLink()} style={{ 'color': 'inherit' }}>
                                    <i
                                        className="fas fa-exclamation-triangle" /> {entityVersion.kindVersionSummary.version} (Latest: {entityVersion.kindVersionSummary.kindVersionCurrent})
                                </Link>
                            </InfoBoxBody>
                            :
                            <InfoBoxBody className="text-success fw-bold">
                                <Link to={kindLink()} style={{ 'color': 'inherit' }}>
                                    <i
                                        className="far fa-check-circle" /> {entityVersion.kindVersionSummary.version} (Latest)
                                </Link>
                            </InfoBoxBody>
                        }
                    </InfoBox>
                </Col>

                <Col sm="6" md="3">
                    <InfoBox>
                        <InfoBoxHeader><i className="far fa-calendar-alt" />Updated On</InfoBoxHeader>
                        <InfoBoxBody>{entityVersion.createdAt !== '' && formatISODateStringAsLocal(entityVersion.createdAt)}, {entityVersion.createdBy}</InfoBoxBody>
                    </InfoBox>
                </Col>
                <Col>
                    <InfoBox>
                        <InfoBoxHeader><i className="far fa-comment" />Last comment</InfoBoxHeader>
                        <InfoBoxBody><AbbreviatedString value={`"${comment}"`} lengthToAbbreviate={30} /></InfoBoxBody>
                    </InfoBox>
                </Col>
                {!currentKindVersion.isStaticData &&
                    <Col sm="6" md="3">
                        <InfoBox>
                            <InfoBoxHeader><i className="fas fa-play-circle" />In Distribution</InfoBoxHeader>
                            <InfoBoxBody>
                                {entityVersion.inLatestDistribution &&
                                    <i className="fas fa-check-circle text-success" />}
                                {!entityVersion.inLatestDistribution && entityVersion.inAnyDistribution &&
                                    <i className="fas fa-check-circle text-warning" />}
                                {!entityVersion.inLatestDistribution && !entityVersion.inAnyDistribution &&
                                    <i className="fas fa-times-circle text-danger" />}
                            </InfoBoxBody>
                        </InfoBox>
                    </Col>
                }
                {!currentKindVersion.isStaticData &&
                    <Col>
                        <InfoBox>
                            <InfoBoxHeader><i
                                className={`fas fa-eye ${statusToggleClasses[entityVersion.entity.status]}`} />Status</InfoBoxHeader>
                            <InfoBoxBody className="text-capitalize" data-testid="txtStatusEntity"><strong
                                className={`${statusToggleClasses[entityVersion.entity.status]}`}>{`${entityVersion.entity.status}`}</strong></InfoBoxBody>
                        </InfoBox>
                    </Col>
                }
            </Row>
        </CollapsePanel>
    );
});
